/* eslint-disable class-methods-use-this */
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend.ts'
import {UIManagerEvents} from '../../../shared/scripts/ui_html/UIManagerEvents.ts'
import {UIWAdController} from '../ui_ad/UIWAdController.ts'
import {type UIManager} from './UIManager.ts'
import {Scene} from './UISceneTypes.ts'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {type UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController.ts'

export class UIWManagerEvents extends UIManagerEvents {
    protected readonly uiManager: UIManager | undefined

    constructor(uiManager: UIManager | undefined) {
        super()
        this.uiManager = uiManager
    }

    async createClickedJoinRoomCallback(gameId: string) {
        await UIWAdController.initiatePopupActionFromUserState(this.uiManager?.adController.adblockState.isAdblockActive ?? false)
        await SocketLobbySend.clickedJoinRoom(gameId)
    }

    isSceneLobby(): boolean {
        return this.uiManager?.sceneController.scene != Scene.Lobby
    }

    isSceneGame(): boolean {
        return this.uiManager?.sceneController.scene == Scene.Game
    }

    leaveRoomAndJoinRoom(roomId: string) {
        navigateToPage(`#${roomId}`, false)
    }

    handleUrlRedirectViaParameters(parameter: UIUrlParameterNames, parameterValue: any) {
        navigateToPage(getHomepageUrlWithParameter(parameter, parameterValue))
    }

    premiumMembershipCheckAction() {
        return () => {
            navigateToPage('/store#membership', true)
        }
    }

    shareImage(title: string, text: string, link: string, imageFile: File, imageSrc: string) {
        return
    }
}
